(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customElements.get('collection-showcase')) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class CollectionShowcase extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cs-track]');
      this.prevBtn = this.querySelector('[data-cs-prev]');
      this.nextBtn = this.querySelector('[data-cs-next]');
      this.controls = this.querySelector('[data-cs-controls]');
      if (!this.track) return;

      this._update = this._raf(this._render.bind(this));
      this._onKey = this._onKey.bind(this);
      this._onPrev = function () { this._page(-1); }.bind(this);
      this._onNext = function () { this._page(1); }.bind(this);

      this.track.addEventListener('scroll', this._update, { passive: true });
      this.track.addEventListener('keydown', this._onKey);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._update);
        this._ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._update);
      }

      requestAnimationFrame(this._render.bind(this));
    }

    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('scroll', this._update);
        this.track.removeEventListener('keydown', this._onKey);
      }
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
      if (this._ro) this._ro.disconnect();
      window.removeEventListener('resize', this._update);
    }

    _raf(fn) {
      var ticking = false;
      return function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; fn(); });
      };
    }

    _step() {
      var card = this.track.querySelector('.collection-showcase__card');
      if (!card) return Math.max(1, this.track.clientWidth * 0.8);
      var cs = getComputedStyle(this.track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    _page(dir) {
      var step = this._step();
      var perView = Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
      this.track.scrollBy({
        left: step * perView * dir,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    _onKey(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); this._page(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this._page(1); }
    }

    _render() {
      if (!this.track) return;
      var sl = this.track.scrollLeft;
      var max = this.track.scrollWidth - this.track.clientWidth;
      var overflows = max > 2;

      this.toggleAttribute('data-cs-overflow', overflows);
      if (this.controls) this.controls.hidden = !overflows;
      if (this.prevBtn) this.prevBtn.disabled = sl <= 2;
      if (this.nextBtn) this.nextBtn.disabled = sl >= max - 2;
    }
  }

  window.customElements.define('collection-showcase', CollectionShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-mobrio"] && !Shopify.designMode) return;
  try {
    
(function(){
  function isValidEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  /* ---------- Newsletter (Klaviyo API — sin form nativo, sin captcha) ---------- */
  function initNewsletter(wrapper){
    if(wrapper.dataset.mfInit === '1') return;
    wrapper.dataset.mfInit = '1';

    var input = wrapper.querySelector('input[type="email"]');
    var btn = wrapper.querySelector('[data-mf-submit]');
    var msg = wrapper.querySelector('.mf-nl__msg');
    var klaviyoKey = (wrapper.getAttribute('data-klaviyo-key') || '').trim();
    var klaviyoList = (wrapper.getAttribute('data-klaviyo-list') || '').trim();
    if(!btn || !input) return;

    function showMsg(text, type){
      if(!msg) return;
      msg.textContent = text;
      msg.classList.remove('mf-nl__msg--ok','mf-nl__msg--error');
      if(type) msg.classList.add('mf-nl__msg--' + type);
      msg.classList.remove('is-visible'); void msg.offsetWidth; msg.classList.add('is-visible');
    }

    /* Suscripción a Klaviyo (Client API v2024). No pasa por Shopify → sin captcha. */
    function subscribeKlaviyo(email){
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: klaviyoList } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      });
    }

    function submit(){
      var email = input.value.trim();
      if(!isValidEmail(email)){ showMsg('Introduce un email válido.','error'); input.focus(); return; }
      if(wrapper.classList.contains('is-loading')) return;
      wrapper.classList.add('is-loading');
      showMsg('','');

      if(!klaviyoKey || !klaviyoList){
        wrapper.classList.remove('is-loading');
        showMsg('Configura la clave y la lista de Klaviyo en el editor del tema.','error');
        return;
      }

      subscribeKlaviyo(email)
        .then(function(res){
          wrapper.classList.remove('is-loading');
          if(res.status === 202 || res.ok){
            showMsg('✓ ¡Te has suscrito!','ok');
            input.value='';
          } else {
            showMsg('No hemos podido completar la suscripción. Inténtalo de nuevo.','error');
          }
        })
        .catch(function(){
          wrapper.classList.remove('is-loading');
          showMsg('Ha ocurrido un error. Inténtalo de nuevo.','error');
        });
    }

    btn.addEventListener('click', submit);
    input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); submit(); } });
  }

  /* ---------- Modal ---------- */
  function initModal(root){
    if(root.dataset.mfInit === '1') return;   /* evita listeners duplicados */
    root.dataset.mfInit = '1';

    var modal = root.querySelector('[data-mf-modal]');
    if(!modal) return;
    var dialog = modal.querySelector('[data-mf-dialog]');
    var openBtn = root.querySelector('[data-mf-open-modal]');
    var closeEls = modal.querySelectorAll('[data-mf-close-modal]');
    var overlay = modal.querySelector('[data-mf-overlay]');
    var bodyView = modal.querySelector('[data-mf-modal-body]');
    var successView = modal.querySelector('[data-mf-modal-success]');
    var form = modal.querySelector('form');
    var msg = modal.querySelector('[data-mf-modal-msg]');
    var lastFocused = null;
    var scrollY = 0;

    function lockScroll(){
      scrollY = window.scrollY;
      var sw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.position='fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left='0'; document.body.style.right='0';
      if(sw>0) document.body.style.paddingRight = sw + 'px';
    }
    function unlockScroll(){
      document.body.style.position=''; document.body.style.top='';
      document.body.style.left=''; document.body.style.right=''; document.body.style.paddingRight='';
      window.scrollTo(0, scrollY);
    }

    /* Focus-trap SOLO en Tab. No reenfoca en ningún otro evento → no bloquea la escritura. */
    function onKey(e){
      if(e.key === 'Escape'){ e.preventDefault(); close(); return; }
      if(e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(
        dialog.querySelectorAll('a[href],button:not([disabled]),textarea,input:not([type="hidden"]),select,[tabindex]:not([tabindex="-1"])')
      ).filter(function(el){ return el.offsetParent !== null; });
      if(!f.length) return;
      var first = f[0], last = f[f.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }

    function open(){
      lastFocused = document.activeElement;
      modal.hidden = false; lockScroll();
      requestAnimationFrame(function(){ modal.classList.add('is-open'); });
      document.addEventListener('keydown', onKey);
      var t = dialog.querySelector('textarea, input:not([type="hidden"])');
      if(t){ setTimeout(function(){ t.focus({preventScroll:true}); }, 80); }
    }
    function close(){
      modal.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      var closed = false;
      var done = function(){
        if(closed) return; closed = true;
        modal.hidden = true; unlockScroll();
        dialog.removeEventListener('transitionend', done);
        if(lastFocused && lastFocused.focus) lastFocused.focus();
      };
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){ done(); }
      else { dialog.addEventListener('transitionend', done); setTimeout(done, 400); }
    }

    if(openBtn) openBtn.addEventListener('click', open);
    closeEls.forEach(function(el){ el.addEventListener('click', close); });

    /* Overlay: cerrar solo si el click NACE y TERMINA en el overlay.
       Evita cierres accidentales al seleccionar texto y arrastrar fuera. */
    if(overlay){
      var downOnOverlay = false;
      overlay.addEventListener('mousedown', function(e){ downOnOverlay = (e.target === overlay); });
      overlay.addEventListener('mouseup', function(e){ if(downOnOverlay && e.target === overlay){ close(); } downOnOverlay = false; });
      overlay.addEventListener('touchstart', function(e){ downOnOverlay = (e.target === overlay); }, {passive:true});
      overlay.addEventListener('touchend', function(e){ if(downOnOverlay && e.target === overlay){ close(); } downOnOverlay = false; });
    }

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var email = form.querySelector('input[type="email"]');
        if(email && email.value.trim() && !isValidEmail(email.value.trim())){
          if(msg){ msg.textContent='Introduce un email válido.'; msg.className='mf-modal__msg mf-modal__msg--error is-visible'; }
          email.focus(); return;
        }
        if(form.classList.contains('is-loading')) return;
        form.classList.add('is-loading'); if(msg){ msg.className='mf-modal__msg'; msg.textContent=''; }
        fetch(form.action, { method:'POST', body:new FormData(form), headers:{'Accept':'text/html'} })
          .then(function(res){ return res.text().then(function(html){ return {ok:res.ok, html:html}; }); })
          .then(function(r){
            form.classList.remove('is-loading');
            var l = r.html.toLowerCase();
            if(r.ok && l.indexOf('field--error')===-1 && l.indexOf('form__message--error')===-1){
              if(bodyView) bodyView.hidden = true;
              if(successView) successView.hidden = false;
            } else {
              if(msg){ msg.textContent='No hemos podido enviar tu petición. Inténtalo de nuevo.'; msg.className='mf-modal__msg mf-modal__msg--error is-visible'; }
            }
          })
          .catch(function(){
            form.classList.remove('is-loading');
            if(msg){ msg.textContent='No hemos podido enviar tu petición. Inténtalo de nuevo.'; msg.className='mf-modal__msg mf-modal__msg--error is-visible'; }
          });
      });
    }
  }

  function boot(){
    document.querySelectorAll('[data-mf-newsletter]').forEach(initNewsletter);
    document.querySelectorAll('.mobrio-footer').forEach(initModal);
  }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }

  /* Reinicializa en el Theme Editor cuando se recarga la sección */
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
